import React from 'react';
import './AnimatedWaves.css';

const AnimatedWaves = ({ className, style }) => {
  return (
    <div className={`waves-container ${className || ''}`} style={style}>
      <svg
        className="waves-svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        {/* Wave 1: Back Wave */}
        <path
          className="wave-path wave-back"
          d="M 0 80 C 300 15, 300 115, 600 80 C 900 15, 900 115, 1200 80 C 1500 15, 1500 115, 1800 80 C 2100 15, 2100 115, 2400 80 L 2400 120 L 0 120 Z"
        />
        {/* Wave 2: Middle Wave */}
        <path
          className="wave-path wave-middle"
          d="M 0 60 C 300 110, 300 10, 600 60 C 900 110, 900 10, 1200 60 C 1500 110, 1500 10, 1800 60 C 2100 110, 2100 10, 2400 60 L 2400 120 L 0 120 Z"
        />
        {/* Wave 3: Front Wave */}
        <path
          className="wave-path wave-front"
          d="M 0 65 C 300 5, 300 115, 600 65 C 900 5, 900 115, 1200 65 C 1500 5, 1500 115, 1800 65 C 2100 5, 2100 115, 2400 65 L 2400 120 L 0 120 Z"
        />
      </svg>
    </div>
  );
};

export default AnimatedWaves;
